import { DollarSign } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import heroImage from "@/assets/debt-collection.jpg";

const DebtCollection = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Commercial Debt Collection Services</h2>
          <p className="text-lg text-muted-foreground">
            Efficient recovery of commercial debts and accounts receivable for Texas businesses. We use negotiation, litigation, and enforcement to collect what you're owed while maintaining professional relationships.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Debt Collection" subtitle="Recover Your Business Assets" icon={<DollarSign className="h-16 w-16 text-accent" />} mainContent={mainContent} heroImage={heroImage} />;
};
export default DebtCollection;